<template>
  <div>
    <div class="flexBlock mt-0 mb-7 header-user-block" style="min-height: 57px;">
      <section class="flex">
        <!-- Основной селект пользователя -->
        <div class="user-head-block" style="min-width: 327px; min-height: 58px;">
          <div class="container-text" style="width: 100%; margin: 0;">
            <multiselect
              :class="multiselectClass"
              style="font-size: 13px; font-family: 'Montserrat', sans-serif;"
              v-model="value"
              placeholder="Введите для поиска"
              label="title"
              track-by="id"
              :options="options"
              :option-height="104"
              :custom-label="customLabel"
              :show-labels="false"
              :allow-empty="allowEmpty"
              @input="onUserSelect"
            >
              <span slot="noResult">Пользователи не найдены</span>

              <!-- отображение выбранного -->
              <template slot="singleLabel" slot-scope="props">
                <div style="display:flex; align-items: center;">
                  <span style="display:none">{{ props.option.id }}</span>

                  <div v-if="hasImage(props.option.img) && hasValue"
                       class="custom-bg-img"
                       :style="getStyle(props.option.img)">
                  </div>

                  <img v-else-if="hasValue"
                       class="option__image select-img"
                       style="margin-right: 10px; height: 40px; width: 40px; border-radius: 40px"
                       src="@/assets/img/no-foto.png"/>

                  <img v-else
                       class="option__image select-img"
                       style="margin-right: 10px; height: 40px; width: 40px; border-radius: 40px"
                       src="@/assets/img/what-user.png"/>

                  <span class="option__desc">
                    <p style="font-size: 12px;">
                      {{ hasValue ? 'Выбранный пользователь' : 'Пользователь не выбран' }}
                    </p>
                    <h4 style="font-size: 14px;">{{ props.option.title }}</h4>
                  </span>
                </div>
              </template>

              <!-- вариант в списке -->
              <template slot="option" slot-scope="props">
                <div style="display:flex; align-items: center;">
                  <span style="display:none">{{ props.option.id }}</span>

                  <div v-if="hasImage(props.option.img)"
                       class="custom-bg-img"
                       :style="getStyleSmall(props.option.img)">
                  </div>

                  <img v-else
                       class="option__image select-img"
                       style="margin-right: 10px; border-radius: 30px"
                       src="@/assets/img/no-foto.png"/>

                  <div class="option__desc">
                    <span class="option__title"
                          style="font-size: 13px; font-family: 'Montserrat', sans-serif;">
                      {{ props.option.title }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <!-- Кнопка отвязать пользователя -->
        <div v-show="delUser && hasValue" class="user-head-block">
          <v-btn class="cancel-btn-user"
                 title="Отвязать пользователя"
                 variant="text"
                 text
                 @click="clearUser">
            <v-icon>ti-close</v-icon>
          </v-btn>
        </div>

        <!-- селект типа навыков -->
        <div v-show="secondBtn"
             class="user-head-block"
             style="margin-left: 10px;">
          <div class="container-text" style="width: 100%; margin: 0;">
            <multiselect
              class="custom-ul"
              v-model="valueSkill"
              placeholder="Выберите тип скиллов"
              label="title"
              track-by="title"
              :options="optionsSkill"
              :custom-label="customLabel"
              :searchable="false"
              :allow-empty="false"
              select-label=""
              selected-label=""
              deselect-label=""
            >
              <template slot="singleLabel" slot-scope="props">
                <div style="display:flex; align-items: center;">
                  <span class="option__desc" style="height: 40px; padding-top: 2px;">
                    <p style="font-size: 12px;">Тип скиллов</p>
                    <h4 style="font-size: 14px;">{{ props.option.name }}</h4>
                  </span>
                </div>
              </template>

              <template slot="option" slot-scope="props">
                <div style="display:flex; align-items: center;">
                  <div class="option__desc">
                    <span class="option__title"
                          style="font-size: 14px; font-family: 'Montserrat', sans-serif;">
                      {{ props.option.name }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
      </section>

      <div v-if="userID && !hiddenBtnInterwiew" class="group-btn mt-2">
        <v-btn
          class="customGlobalBtn primary-btn"
          variant="text"
          text
          @click="addInterview(userID)"
        >
          Назначить интервью
        </v-btn>
      </div>

      <!-- кнопка назад -->
      <div v-if="hasBack" class="group-btn mt-2">
        <v-btn class="customGlobalBtn emptyBtn"
          variant="text"
          text
          @click="goBack"
        >
          Назад
        </v-btn>
      </div>
    </div>

    <hr>
  </div>
</template>

<script>
import GlobalRequest from "@/plugins/globalRequest"
import Multiselect from 'vue-multiselect'
import globalMethods from "@/plugins/globalMethods"

export default {
  name: "EditedUser",

  components: { GlobalRequest, Multiselect, globalMethods },

  props: ["userID", "typeSkill", "secondBtn", "delUser", "emptyUser", "getStorageUser", "users", "hiddenBtnInterwiew"],

  data() {
    return {
      currentUserID: this.userID,
      value: {},
      options: [],
      user: {},
      valueSkill: {},
      optionsSkill: [
        { title: "hs", name: "Hard Skills" },
        { title: "ss", name: "Soft Skills" }
      ]
    }
  },

  computed: {
    hasValue() {
      return Object.keys(this.value).length > 0;
    },

    hasBack() {
      return this.$route && this.$route.query && this.$route.query.back;
    },

    allowEmpty() {
      return this.delUser === true;
    },

    multiselectClass() {
      return this.delUser && this.hasValue
        ? "custom-ul multisel-custom-border"
        : "custom-ul";
    }
  },

  watch: {
    // value(val) {
    //   this.$emit("getCurrentUser", val && val.id ? val.id : null);
    // },

    valueSkill(val) {
      this.$emit("getSkillType", val ? val.title : null);
    },

    typeSkill: {
      immediate: true,
      handler() {
        this.initSkillType();
      }
    },

    users: {
      handler(newVal) {
        this.loadAvailableUsers(newVal);
        this.$nextTick(() => {
          this.syncSelectedUser();
        });
      },
      immediate: true,
      deep: true
    },

    userID: {
      immediate: true,
      handler() {
        this.syncSelectedUser();
      }
    },
    
  },

  async mounted() {
    // await this.loadUser(this.userID);
    // this.initSkillType();
  },

  methods: {
    // ----------------------------------------------------
    // utils
    // ----------------------------------------------------
    hasImage(img) {
      return img && img !== "noFoto";
    },

    getStyle(path) {
      return `margin-right:10px; background-image:url("${path}"); height:40px; width:40px; border-radius:40px;`;
    },

    getStyleSmall(path) {
      return `margin-right:10px; background-image:url("${path}"); height:30px; width:30px; border-radius:30px;`;
    },

    customLabel(item) {
      if (!item) return "";
      return item.title || "";
    },

    clearUser() {
      this.value = {};
      this.$emit("getCurrentUser", null);
    },

    initSkillType() {
      var skill = this.typeSkill ? this.typeSkill : "hs";

      this.valueSkill = skill === "ss"
        ? this.optionsSkill[1]
        : this.optionsSkill[0];
    },

    // ----------------------------------------------------
    // data loading
    // ----------------------------------------------------
    async loadUser(id) {
      let realId = id;

      if (!realId && this.getStorageUser) {
        const stored = localStorage.getItem("appointment_user");
        if (stored && stored !== "0") realId = stored;
      }

      if (!realId) {
        realId = localStorage.getItem("current_user");
      }

      this.currentUserID = realId;

      // Если emptyUser = true — не загружаем данные
      if (!this.emptyUser && realId) {
        const res = await GlobalRequest.request("/user/" + realId, "GET");
        this.user = res.data || {};
        this.value = this.mapUserToOption(this.user);
      }

      await this.loadAvailableUsers(this.users);
    },

    async loadAvailableUsers(users) {
      this.options = [];

      if(!users) return;

      this.populateOptions(users);
    },

    populateOptions(data) {
      if (!Array.isArray(data)) return;

      const arr = [];

      for (let i = 0; i < data.length; i++) {
        const u = data[i];
        const last = u.lastName ? u.lastName : "";
        arr.push({
          id: u.id,
          title: u.name + " " + last,
          img: u.avatar ? u.avatar : "noFoto"
        });
      }

      arr.sort((a, b) => (a.title > b.title ? 1 : -1));

      this.options = arr;

      // if (!this.emptyUser) {
      //   const found = arr.find(o => o.id == this.currentUserID);
      //   if (found) this.value = found;
      // }
    },

    mapUserToOption(u) {
      const last = u.lastName ? u.lastName : "";
      return {
        id: u.id,
        title: u.name + " " + last,
        img: u.avatar ? u.avatar : "noFoto"
      };
    },

    syncSelectedUser() {
      if (!this.userID || !this.options.length) {
        this.value = {};
        return;
      }

      const found = this.options.find(
        o => String(o.id) === String(this.userID)
      );

      if (found) {
        this.value = found;
      }
    },

    onUserSelect(val) {
      if (!val || !val.id) return;
      this.$emit("getCurrentUser", val.id);
    },

    // ----------------------------------------------------
    // navigation
    // ----------------------------------------------------
    goBack() {
      const q = this.$route.query;
      this.$router.push({ name: q.back, query: q });
    },

    addInterview(id) {
      this.$emit("addInterview", id || 0);
    },
    
  }
};
</script>

<style>
  .cancel-btn-user {
    padding: 0 !important;
    min-width: 0 !important;
    height: 100% !important;
    width: 22px;
    border-radius: 0 5px 5px 0 !important;
    background: #dfe0e0;
  }
  .cancel-btn-user i {
    font-size: 12px !important;
  }
  .multisel-custom-border .multiselect__tags {
    border-radius: 5px 0 0 5px;
  }
</style>
